import React from "react";
import { Box, Button, Typography, Stack, FormControl, Select, MenuItem } from "@mui/material";
import { useFormik } from "formik";
import { FormTextField } from "../../components/generic/GenericTextFields";
import useStore from "../../states/store";
import { sendReferralContactUsEmail } from "../../config/apisauce";
import useNotiStack from "../../hooks/useNotiStack";
import { boolean, object, string } from "yup";

const validationSchema = object().shape({
  name: string().required("Name is required"),
  email: string().email("Invalid email").required("Email is required"),
  onWannaCollab: boolean().required("Please select an option"),
  message: string().required("Message is required"),
});

const ReferralReachOutForm = () => {
  const [{ loaderState }, { openLoader, closeLoader }] = useStore();
  const { success } = useNotiStack();

  const handleSendReferralContactUsEmail = async (params) => {
    openLoader();
    const { ok } = await sendReferralContactUsEmail(params);
    if (ok) {
      success("Successfully submitted!");
    }
    closeLoader();
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      onWannaCollab: null,
      message: "",
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      handleSendReferralContactUsEmail(values);
      resetForm();
    },
  });

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Stack gap={2.5}>
          <FormTextField
            value={formik.values.name}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            handleChange={(value) => formik.setFieldValue("name", value)}
            label={"Name"}
            placeholder={"Name"}
          />

          <FormTextField
            value={formik.values.email}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            handleChange={(value) => formik.setFieldValue("email", value)}
            label={"Email"}
            placeholder={"Email"}
            type="email"
          />

          <FormControl fullWidth margin="normal" sx={{ gap: 1, mt: 0 }}>
            <Typography color="text.light" fontWeight={700}>
              Are you on WannaCollab?<span style={{ color: "#F96D82" }}>*</span>
            </Typography>
            <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
              <Select
                displayEmpty
                name="onWannaCollab"
                value={formik.values.onWannaCollab}
                onChange={formik.handleChange}
                error={formik.touched.onWannaCollab && Boolean(formik.errors.onWannaCollab)}
                sx={{
                  borderRadius: "10px",
                }}
              >
                <MenuItem value={null} disabled>
                  Select an option
                </MenuItem>
                <MenuItem value={true}>Yes, I&apos;m already a member.</MenuItem>
                <MenuItem value={false}>No, I&apos;m not a member yet.</MenuItem>
              </Select>
              {formik.touched.onWannaCollab && formik.errors.onWannaCollab && (
                <Typography color="error" variant="caption" sx={{ mt: 0.5, mx: "14px" }}>
                  {formik.errors.onWannaCollab}
                </Typography>
              )}
            </Box>
          </FormControl>

          <FormTextField
            label="Message"
            name="message"
            multiline
            rows={5}
            value={formik.values.message}
            handleChange={(value) => formik.setFieldValue("message", value)}
            error={formik.touched.message && Boolean(formik.errors.message)}
            helperText={formik.touched.message && formik.errors.message}
          />

          <Button disabled={loaderState} type="submit" variant="contained" sx={{ mt: 2 }}>
            Submit
          </Button>
        </Stack>
      </form>
    </Box>
  );
};

export default ReferralReachOutForm;
